import { FooterLink } from "data/types";
import React from "react";
import Logo from "shared/Logo/Logo";
import { useData } from "data/data-provider";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: FooterLink[];
}

const Footer: React.FC = () => {
  const { socialItems, address, contactItems, footerItems } = useData();

  if (
    (!socialItems || socialItems.length === 0) &&
    (!address || address.length === 0) &&
    (!contactItems || contactItems.length === 0) &&
    (!footerItems || footerItems.length === 0)
  ) {
    return <div />;
  }
  return (
    <div className="nc-Footer relative py-8 border-t border-secondary-100 bg-bg-color">
      <div className="container grid grid-cols-1 gap-y-10 gap-x-4 sm:gap-x-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8">
        <div className="col-span-1 md:col-span-2 lg:col-span-1">
          <div className="flex flex-col gap-5">
            <div>
              <Logo />
            </div>
            <div className="grid grid-cols-2 gap-3">
              {socialItems.map((item: any, index: any) => (
                <a
                  key={item.id || index}
                  href={item.description}
                  className="underline font-bold text-sm hover:opacity-80 transition"
                >
                  {item.heading.toUpperCase()}
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="text-sm">
          <h2 className="font-bold text-text-color mb-5">Address</h2>
          <div className="space-y-3">
            {address.map((item: any, index: any) => (
              <p key={item.id || index} className="text-text-color break-words text-xs sm:text-sm">
                {item.description}
              </p>
            ))}
          </div>
        </div>
        <div className="text-sm">
          <h2 className="font-bold text-text-color mb-5">Contact Us</h2>
          <div className="space-y-3">
            {contactItems.map((item: any, index: any) => (
              <div key={item.id || index}>
                {item.heading ? (
                  <a
                    className="text-text-color hover:underline transition text-xs sm:text-sm"
                    href={item.description}
                  >
                    {item.heading}
                  </a>
                ) : (
                  <p className="text-text-color break-words text-xs sm:text-sm">
                    {item.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
        <div className="text-sm">
          <h2 className="font-bold text-text-color mb-5">Links</h2>
          <div className="space-y-3">
            {footerItems.map((item: any, index: any) => (
              <div key={item.id || index}>
                {item.heading ? (
                  <a
                    className="text-text-color hover:underline transition text-xs sm:text-sm"
                    href={item.description}
                  >
                    {item.heading}
                  </a>
                ) : (
                  <p className="text-text-color break-words text-xs sm:text-sm">
                    {item.description}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
